<template>

    <modal :show="showModal">

        <div class="mta">
            
            <img src="/img/newsletters-v2/x-blue.svg" class="mta__close" v-show="isDesktop" @click="close">

            <div class="mta__bubble"
                 :class="{
                'mta__bubble__delete': enumAction === ENUM.NEWSLETTERS.ACTIONS.DELETE,
                'mta__bubble__unsub': enumAction === ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES,
                'mta__bubble__keep': enumAction === ENUM.NEWSLETTERS.ACTIONS.KEEP
            }">

                <img class="img__24" :src="imgSrc">

            </div>

            <markdown class="text-lSemibold mt__16" :text="firstText"></markdown>

            <markdown class="text-baseRegular-2 color__moon mt__8" :text="secondText"></markdown>

            <div class="mta__btn__container">

                <button class="mta__btn"
                        :class="{
                'mta__btn__delete': enumAction === ENUM.NEWSLETTERS.ACTIONS.DELETE,
                'mta__btn__unsub': enumAction === ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES,
                'mta__btn__keep': enumAction === ENUM.NEWSLETTERS.ACTIONS.KEEP
            }"
                        @click="close(true)">
                    {{ $t('pop_up_rollback_autodelete_cta_confirm') }}
                </button>

                <button class="mta__btn mta__btn__white" @click="close(false)">
                    {{ $t('pop_up_autodelete_cta_cancel') }}
                </button>

            </div>

            <div class="mta__bottom" @click="checked = !checked">

                <img :src="checked ? '/img/newsletters-v2/checkbox-on.svg' : '/img/newsletters-v2/checkbox-off.svg'"
                     class="img__20 mr__4">

                <p>{{ $t('pop_up_delete_no_confirmation') }}</p>

                <div></div>

            </div>

        </div>

    </modal>

</template>

<script>
import ENUM from '@/assets/ENUM'

import Storage from '@/helpers/storage'

import Tag from '@/modules/tag'

import Markdown from '@/components/Markdown'
import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-tuto-action',

    components: {
        Markdown,
        Modal
    },

    computed: {
        ENUM() {
            return ENUM
        },
        sendersLength() {
            return this.senders.length
        },

        sendersTotal() {
            return this.senders.reduce((accumulator, item) => {
                return accumulator + item.count
            }, 0)
        },

        firstText() {
            switch (this.enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    return this.$tc('cleaning_confirm_keep', this.sendersLength, {nb_selected: this.sendersLength})
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    return this.$tc('cleaning_confirm_autodelete', this.sendersLength)
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    return this.$tc('cleaning_confirm_delete', this.sendersLength, {nb_selected: this.sendersLength})
            }
        },

        secondText() {
            switch (this.enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    return this.$tc('pop_up_keep_total_emails', this.sendersLength)
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    return this.$tc('cleaning_confirm_nb_autodelete', this.sendersTotal, {nb_total: this.sendersTotal})
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    return this.$tc('pop_up_delete_total_emails', this.sendersTotal, {numberOfEmails: this.sendersTotal})
            }
        },

        imgSrc() {
            switch (this.enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    return '/img/newsletters-v2/archive-i-os-white.svg'
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    return '/img/newsletters-v2/delete-white-auto.svg'
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    return '/img/newsletters-v2/delete-white-simple.svg'
            }
        }
    },

    data() {
        return {
            showModal: false,
            senders: [],
            checked: false,
            enumAction: ''
        }
    },

    methods: {

        open(senders, enumAction) {
            this.senders = senders
            this.enumAction = enumAction
            switch (enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    Tag.popupAll(this, 'confirmation_keep')
                    break
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    Tag.popupAll(this, 'confirmation_unsub')
                    break
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    Tag.popupAll(this, 'confirmation_delete')
                    break
            }
            this.showModal = true
        },

        close(accept = false) {

            Tag.clickGA(this, 'next')

            if (this.checked) {
                Tag.clickAmplitude(this, 'do_not_ask')

                switch (this.enumAction) {
                    case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                        Storage.setItem('disableModalKeep', true)
                        break
                    case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                        Storage.setItem('disableModalUnsubscribe', true)
                        break
                    case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                        Storage.setItem('disableModalDelete', true)
                        break
                }
            }

            Tag.clickAmplitude(this, accept ? 'confirm' : 'cancel')

            this.showModal = false

            this.$emit('close', {
                accept: accept,
                enumAction: this.enumAction,
                senders: this.senders
            })
        }
    }
}

</script>

<style lang="scss" scoped>

.mta {
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 400px;
    position: relative;

    @media screen and (min-width: $above-tablet-length) {
        padding: 48px 24px 24px;
    }

    &__bubble {
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 72px;

        &__delete {
            background-color: $sunset;
            border: solid 4px #f9d3b9;
        }

        &__unsub {
            background-color: $raspberry;
            border: solid 4px #fbc5d2;
        }

        &__keep {
            background-color: $lime;
            border: solid 4px #aef1dc;
        }
    }

    &__btn {
        padding: 17px;
        border-radius: 72px;
        width: 100%;
        color: $white;
        @media screen and (min-width: $above-tablet-length) {
            width: inherit;
        }

        &__container {
            display: flex;
            flex-direction: column;
            width: 100%;
            margin: 16px 0;

            @media screen and (min-width: $above-tablet-length) {
                flex-direction: row;
                padding: 32px 0 40px;
            }
        }

        &__delete {
            background-color: $sunset;
            @media screen and (min-width: $above-tablet-length) {
                margin-right: 4px;
            }
        }

        &__unsub {
            background-color: $raspberry;
            @media screen and (min-width: $above-tablet-length) {
                margin-right: 4px;
            }
        }

        &__keep {
            background-color: $lime;
            @media screen and (min-width: $above-tablet-length) {
                margin-right: 4px;
            }
        }

        &__white {
            padding: 13px;
            background-color: $white;
            color: $midnight;
            border: solid 4px #e7e7e8;
            margin-top: 8px;
            @media screen and (min-width: $above-tablet-length) {
                margin-top: 0;
                margin-left: 4px;
            }
        }
    }

    &__close {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 24px;
        right: 24px;
        cursor: pointer;
    }

    &__bottom {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
